import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Flag, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

export class Flags {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Flag>> => {
    const response = await this.api.get('/shipments/orders/flags', config)
    return paginatedTransform(Flag)(response.data)
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<Flag> => {
    const response = await this.api.post('/shipments/orders/flags', data, config)
    return rawTransform(Flag)(response.data)
  }
}
